export default "https://d1e6s5z4lzmgxx.cloudfront.net/ba82fc54-f5ca-4442-8850-d050cbc89c21/images/rushing-icon.svg?a6fc9c460d0598538acdfd6a3f03db1f";